export default __webpack_public_path__ + "static/media/easydatastructures.8ec1d996.png";